export default __webpack_public_path__ + "static/media/6.4d9509f0.jpg";